module.exports = __webpack_public_path__ + "img/les-deux-magot.e4b9fe4f.jpg";